import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Laden } from '../components/common/States'
import { QualyzApi } from '../services/qualyz'
import { fehlerText } from '../lib/api'
import { formatDatum } from '../lib/lenses'
import type { ProAnfrage } from '../services/qualyz'

/**
 * Freigabe über den Link aus der E-Mail -- ohne Anmeldung, das Token ist der
 * Ausweis.
 *
 * Der Link ÖFFNET nur diese Seite; entschieden wird erst per Knopf. Grund:
 * Mailprogramme und Virenscanner rufen Links im Voraus ab, und eine
 * Freischaltung durch einen Scanner wäre schwer zu erklären.
 */
export default function ProFreigabePage() {
  const { token = '' } = useParams()
  const [anfrage, setAnfrage] = useState<ProAnfrage | null>(null)
  const [laedt, setLaedt] = useState(true)
  const [fehler, setFehler] = useState<string | null>(null)
  const [fertig, setFertig] = useState<string | null>(null)
  const [arbeitet, setArbeitet] = useState(false)

  useEffect(() => {
    let vorbei = false
    QualyzApi.proFreigabeAnsehen(token)
      .then((d) => !vorbei && setAnfrage(d.anfrage))
      .catch((f) => !vorbei && setFehler(fehlerText(f)))
      .finally(() => !vorbei && setLaedt(false))
    return () => {
      vorbei = true
    }
  }, [token])

  const entscheiden = async (freischalten: boolean) => {
    setArbeitet(true)
    try {
      await QualyzApi.proFreigabeEntscheiden(token, freischalten)
      setFertig(
        freischalten
          ? `${anfrage?.konto?.email ?? 'Das Konto'} hat jetzt den Pro-Zugang.`
          : 'Die Anfrage ist abgelehnt.',
      )
    } catch (f) {
      setFehler(fehlerText(f))
    } finally {
      setArbeitet(false)
    }
  }

  return (
    <div className="q-page q-page--schmal">
      <section className="q-card">
        <div className="q-card-head">
          <h3 className="q-card-title">Anfrage für den Pro-Zugang</h3>
        </div>
        {laedt && <Laden text="Lade die Anfrage …" />}
        {!laedt && fehler && !fertig && <p className="qa-hinweise">{fehler}</p>}
        {fertig && <p className="q-job-result is-ok">{fertig}</p>}
        {!laedt && !fehler && !fertig && anfrage && (
          <>
            <p className="q-job-text">
              <strong>{anfrage.konto?.email}</strong>
              {anfrage.konto?.name ? ` · ${anfrage.konto.name}` : ''}
              {anfrage.gestellt_am ? ` · gefragt am ${formatDatum(anfrage.gestellt_am.slice(0, 10))}` : ''}
            </p>
            {anfrage.nachricht && <p className="q-anfrage-nachricht">„{anfrage.nachricht}"</p>}
            <div className="q-job-foot">
              <span className="q-job-meta">Dieser Link gilt einmal.</span>
              <span className="q-anfrage-knoepfe">
                <button type="button" className="q-btn q-btn-sm" disabled={arbeitet}
                        onClick={() => entscheiden(false)}>
                  Ablehnen
                </button>
                <button type="button" className="q-btn q-btn-primary q-btn-sm" disabled={arbeitet}
                        onClick={() => entscheiden(true)}>
                  Pro geben
                </button>
              </span>
            </div>
          </>
        )}
      </section>
    </div>
  )
}
